export const OrganogramIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <rect x='7' y='1.5' width='6' height='5' rx='1' fill='currentColor' />
    <rect x='1' y='13.5' width='6' height='5' rx='1' fill='currentColor' />
    <rect x='13' y='13.5' width='6' height='5' rx='1' fill='currentColor' />
    <path
      d='M10 6.5 V 10 M4 10 H 16 M4 10 V 13.5 M16 10 V 13.5'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
